import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.scss'],
})
export class CustomModalComponent implements OnInit {
  @Input() hasButton: boolean;

  constructor(private popoverController: ModalController) {}

  ngOnInit() {}

  close() {
    this.popoverController.dismiss();
  }
}
